/// <reference lib="DOM" />

import type { FileUIPart } from "ai";
import { useState } from "react";

interface ChatImagePartProps {
  part: FileUIPart;
}

/**
 * Inline image thumbnail for a chat-message `FileUIPart`. The composer
 * stores images as `data:` URLs, which `<img>` can decode directly — no
 * fetch dance needed.
 */
export function ChatImagePart({ part }: ChatImagePartProps) {
  const [status, setStatus] = useState<"loading" | "ready" | "error">(
    "loading",
  );

  if (status === "error") {
    return (
      <div className="flex h-24 w-24 items-center justify-center rounded-md bg-muted/40 text-xs italic text-muted-foreground">
        image
      </div>
    );
  }

  return (
    <div className="relative h-24 w-24 overflow-hidden rounded-md bg-muted/40">
      {status === "loading" && (
        <div className="absolute inset-0 animate-pulse bg-muted" />
      )}
      <img
        src={part.url}
        alt={part.filename ?? "attachment"}
        loading="lazy"
        decoding="async"
        draggable={false}
        onLoad={() => setStatus("ready")}
        onError={() => setStatus("error")}
        className="relative h-full w-full object-cover object-center"
      />
    </div>
  );
}
